import DocumentsFolder from './components/Pages/About/Documents/DocumentsFolder/DocumentsFolder';
import DocumentsSlider from './components/Pages/About/Documents/DocumentsSlider/DocumentsSlider';
import ClubInfo from './components/Pages/Catalogs/Catalog/Cards/ClubCard/ClubInfo/ClubInfo';
import Management from './components/Pages/About/Management/Management';
import EventInfo from './components/Pages/Calendar/EventInfo/EventInfo';
import Archive from './components/Pages/Calendar/Archive/Archive';
import Catalog from './components/Pages/Catalogs/Catalog/Catalog';
import Contacts from './components/Pages/About/Contacts/Contacts';
import NewsInfo from './components/Pages/News/NewsInfo/NewsInfo';
import Calendar from './components/Pages/Calendar/Calendar';
import Feedback from './components/Pages/Feedback/Feedback';
import NotFound from './components/Pages/NotFound/NotFound';
import Catalogs from './components/Pages/Catalogs/Catalogs';
import Logos from './components/Pages/About/Logos/Logos';
import About from './components/Pages/About/About';
import { Route, Switch, useLocation } from 'react-router-dom';
import ErrorBoundary from './common/ErrorBoundary/ErrorBoundary';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Main from './components/Pages/Main/Main';
import News from './components/Pages/News/News';
import { useEffect } from 'react';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Прокрутка догори при зміні маршруту.
 * Раніше кожна сторінка викликала window.scrollTo(0, 0) прямо в тілі компонента,
 * тобто побічним ефектом під час рендеру.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

export default function App() {
  const language = useLanguage();
  const { pathname } = useLocation();

  return (
    <div className='app-shell'>
      <a className='skip-link' href='#main'>
        {language === 'en' ? 'Skip to content' : 'Перейти до вмісту'}
      </a>

      <ScrollToTop />
      <Header />

      <main key={pathname} className='page-main page-transition' id='main' tabIndex={-1}>
        {/* key за шляхом: перехід на іншу сторінку виводить застосунок зі стану
            помилки, інакше зламана сторінка лишалася б на екрані до
            перезавантаження вкладки. */}
        <ErrorBoundary key={pathname}>
          <Switch>
            {/* Main Page */}
            <Route exact path='/'>
              <Main />
            </Route>
            {/* Calendar */}
            <Route exact path='/calendar'>
              <Calendar />
            </Route>
            {/* Архів оголошений до /calendar/:eventSlug: інакше «archive»
                прочиталося б як слаг заходу. */}
            <Route exact path='/calendar/archive'>
              <Archive />
            </Route>
            <Route exact path='/calendar/:eventSlug'>
              <EventInfo />
            </Route>
            {/* Catalogs */}
            <Route exact path='/catalogs'>
              <Catalogs />
            </Route>
            <Route exact path='/catalogs/:catalogs'>
              <Catalog />
            </Route>
            {/* Архів реєстру оголошений до /catalogs/:catalogs/:entityId: інакше
                «archive» прочиталося б як ідентифікатор запису. */}
            <Route exact path='/catalogs/:catalogs/archive'>
              <Catalog />
            </Route>
            <Route exact path='/catalogs/clubs/:clubId'>
              <ClubInfo />
            </Route>
            {/* Feedback */}
            <Route exact path='/feedback'>
              <Feedback />
            </Route>
            {/* News */}
            <Route exact path='/news'>
              <News />
            </Route>
            <Route exact path='/news/:articleId'>
              <NewsInfo />
            </Route>
            {/* About */}
            <Route exact path='/about'>
              <About />
            </Route>
            <Route exact path='/logos'>
              <Logos />
            </Route>
            <Route exact path='/management'>
              <Management />
            </Route>
            <Route exact path='/documents'>
              <DocumentsFolder />
            </Route>
            <Route exact path='/documents/:documentsType'>
              <DocumentsSlider />
            </Route>
            <Route exact path='/contacts'>
              <Contacts />
            </Route>
            {/* Not Found */}
            <Route>
              <NotFound />
            </Route>
          </Switch>
        </ErrorBoundary>
      </main>

      <Footer />
    </div>
  );
}
